module.exports = __webpack_public_path__ + "static/media/Muvi-Brand-Icon-Blue.d19de3f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Muvi-Brand-Icon-Blue.svg
// module id = 3793
// module chunks = 0